import * as React from "react";
import { useState } from "react";
import { useLeagues } from "../hooks/useLeague";
import { ISearchLeaguesParams } from "../utils/api.interfaces";
import AutocompleteDebounce from "./AutocompleteDebounce";
import { rowsPerpageOptions } from "./Pagination";

interface LeagueFilterProps {
  initSelectedLeague?: string | null;
  onLeagueChange: (event: React.ChangeEvent<unknown>, newLeague: any) => void;
  countryCode?: string;
}
const FilterLeague: React.FC<LeagueFilterProps> = ({
  onLeagueChange,
  initSelectedLeague,
  countryCode = "",
}) => {
  const initialSearchParams: ISearchLeaguesParams = {
    page: "0",
    NameFilter: "",
    CountryCode: countryCode,
    SportType: "Football",
    pageSize: rowsPerpageOptions[4].toString(),
  };
  const [searchParams, setSearchParams] =
    useState<ISearchLeaguesParams>(initialSearchParams);

  // Update searchParams when countryCode changes
  React.useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      CountryCode: countryCode || "",
    }));
  }, [countryCode]);

  const { dataLeagues } = useLeagues(searchParams);

  const handleFilterLeagueChange = (filterValue: string) => {
    const newParams: any = {
      ...searchParams,
      NameFilter: filterValue,
    };
    setSearchParams(newParams);
  };
  return (
    <div
      style={{
        width: "260px",
        minWidth: "260px",
      }}
    >
      {dataLeagues && (
        <AutocompleteDebounce
          setDefaultValueWithId={initSelectedLeague}
          onFilterChange={(val) => {
            handleFilterLeagueChange(val);
          }}
          handleChange={onLeagueChange}
          data={dataLeagues.leagues}
          labelTitle="League"
        />
      )}
    </div>
  );
};

export default FilterLeague;
